import React from 'react'
import { Box, Text, Title } from '@mantine/core'
import { useVersionRulesCache } from '../../../../hooks/global-job-matching'
import { useParams } from 'react-router'
import { useQueryClient } from 'react-query'
import { QueryKeys } from '../../../../constants/query-keys'
import { DataCutPriority } from '../../GlobalJobMatchingVersioning/types/rules'
import { useAppState } from '../../../../hooks/redux'
import { RulesBasedPricingRule } from '../../../../hooks/rules-based-pricing'

export const DataCutStepDetails = () => {
  const params = useParams<{id: string}>()
  const rules = useVersionRulesCache(params.id)
  const queryClient = useQueryClient()
  const { groups, session: { organization: { defaultGroup }} } = useAppState()

  const dataCutSelection = rules?.dataCutPriority === 'rules_based_pricing' ? 'Rules Based Pricing' : rules?.dataCutPriority === 'group_specific' ? 'Group Level' : 'Site Level'
  const rulesBasedPricingList = queryClient.getQueryData<RulesBasedPricingRule[]>([QueryKeys.RULES_BASED_PRICING_LIST, { notEmpty: true }])

  const getPriorityLabel = (priority: DataCutPriority) => {
    if (priority === 'default') return defaultGroup.name
    if (priority === 'group_specific') {
      const groupLabel = groups.find(g => g.id.toString() === rules?.dataCutPrioritySelection)?.name
      return groupLabel
    }
    if (priority === 'rules_based_pricing') {
      const ruleLabel = rulesBasedPricingList?.find((rule) => rule.id === rules?.dataCutPrioritySelection)?.name
      return ruleLabel
    }
    return undefined
  }

  const priorityLabel = getPriorityLabel(rules?.dataCutPriority)

  return (
    <Box>
      <Title order={3} c='black'>Data Cut</Title>
      <Text c='black' size='sm'>Set to use <Text span fw='bold' c='black' size='sm'>{dataCutSelection}</Text></Text>
      { priorityLabel && <Text c='dimmed' size='sm'>{priorityLabel}</Text> }
    </Box>
  )
}
